import { ProductMake, ProductType, SparepartStatus } from "./enum-type";
import { ProductModel } from "./product-model";

export interface SparePart {
    id: string
    name: string
    frenchName: string
    price: string
    unitInStock: number
    minUnitInStock: number
    reference: string
    notificationEnabled: boolean
    command: string
    stockValue: string
    sparepartStatus: SparepartStatus
    sparepartMake: ProductMake
    productTypes: ProductType[]
    displayName?: string
    productModels: string[]
    productModelIds: string[]
}


export class SparePartExport {
    parts: SparePart[];
}

export function getSparePartExport(spareparts: SparePart[]): SparePartExport {
    const sparePartExport = new SparePartExport();
    sparePartExport.parts = spareparts;
    return sparePartExport;
}